import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledAlert, DescriptionList, DescriptionListItem } from '../style';

interface InformationProps {
  studentsWithoutCalculatedMark: number;
  studentsWithManuallySignedFinalMark: number;
  studentsWithMarksByAnotherCounter: number;
}

/**
 * Komponent do wyświetlenia informacji o braku studentów w tablicy w modalu
 */
const Information = ({
  studentsWithoutCalculatedMark,
  studentsWithManuallySignedFinalMark,
  studentsWithMarksByAnotherCounter,
}: InformationProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledAlert
      message={t('COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_TITLE')}
      description={
        <>
          <DescriptionList>
            {studentsWithoutCalculatedMark > 0 && (
              <DescriptionListItem>
                <strong>{studentsWithoutCalculatedMark}</strong>
                {t('COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION_NO_CALCULATED_MARK')}
              </DescriptionListItem>
            )}
            {studentsWithManuallySignedFinalMark > 0 && (
              <DescriptionListItem>
                <strong>{studentsWithManuallySignedFinalMark}</strong>
                {t('COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION_MANUALLY_SIGNED_MARK')}
              </DescriptionListItem>
            )}
            {studentsWithMarksByAnotherCounter > 0 && (
              <DescriptionListItem>
                <strong>{studentsWithMarksByAnotherCounter}</strong>
                <strong>{t('COPY_FINAL_MARKS_BY_ANOTHER')}</strong>
              </DescriptionListItem>
            )}
          </DescriptionList>

          {t('COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION')}
        </>
      }
    />
  );
};

export default Information;
